// BSL — kavram (i) metinleri (BASLARKEN-PLANI.md §8, süreç planlarının «Kavramlar» bölümleri).
// Form etiketinde FormAlan `bilgi` özelliğiyle, form dışında KavramIpucu.vue ile gösterilir;
// turdaki kavram balonu da aynı metni kullanır. Metin değişirse tek yer burası (§12 bakım kuralı).
export const KAVRAMLAR = {
  // IBS-3 (İşletme Bilgileri)
  sayfaBasligi:
    "Tarayıcı sekmesinde ve maillerin başlığında görünen ad. Boş bırakırsanız işletme adı kullanılır.",
  vergiNo:
    "Şirketse 10 haneli vergi kimlik no (VKN), şahıs işletmesiyse 11 haneli TC kimlik no.",
  // BSL-URN §6
  hareketTipi:
    "Ürünün satışta nasıl davrandığı. Satış: stoklu ürün, girişle stoğa girer. Hizmet: stoksuz. Diyet paketi: süreli program. Studio paketi: ders hakkı.",
  stoklu:
    "Stoklu ürün önce Ürün Giriş ile stoğa girer; girmeden satış ekranında görünmez. Hizmet ve paketler stoksuzdur, hemen satılır.",
  birimMaliyet:
    "Bir adedin size maliyeti, toplam değil. 10 adedi 500 TL'ye aldıysanız 50 yazın. Kâr ve maliyet raporları bundan hesaplanır.",
  kategori:
    "Ürünlerin grubu. Satış ekranındaki kategori düğmeleri ve raporlar buna göre ayrılır. Her ürün bir alt kategoriye bağlanır.",
  // BSL-MUS §7
  potansiyelMusteri:
    "Kayıtlı ama henüz hiç satış yapılmamış müşteri. İlk satışla bu listeden çıkar; satış iptal edilse de geri dönmez.",
  borcluMusteri:
    "Bakiyesi borçta olan müşteri: satışta ödenmeyen kısım borç yazılır. Detay → Ödeme Al ile tahsil edilir.",
  // BSL-ONK §6
  onKayit:
    "Müşterinin bağlantıdan kendisinin doldurduğu başvuru. Kabul ederseniz müşteri kaydı açılır, reddederseniz açılmaz.",
  onaySube:
    "Kabul edilen başvuru bu şubenin müşterisi olur. Başvuru hangi şubenin bağlantısından geldiyse o seçili gelir.",
  // BSL-SAT §5
  alinanUcret:
    "Müşterinin şimdi ödediği tutar. Toplamdan azsa kalan borç yazılır (veresiye); 0 yazarsanız tamamı borç olur.",
  odemeYontemi:
    "Alınan kısmın nasıl ödendiği: nakit, kart, havale ya da diğer. Kasa raporları yönteme göre ayrılır.",
  bakiye:
    "Müşterinin önceden ödediği ya da iadeden kalan para. Sonraki satışlarda borçtan kendiliğinden düşülür.",
  // BSL-RDV §6
  randevuSuresi:
    "Takvimdeki saat dilimi. Süresi tanımlı hizmet kendi süresini kullanır; «Genel» randevu bu süreyi alır.",
  tampon:
    "İki randevu arasında boş bırakılan süre: temizlik, hazırlık. Müşteri bu aralığa randevu alamaz.",
  esZamanli:
    "Aynı saate alınabilecek randevu sayısı. Tek koltuk ya da tek oda için 1 yazın.",
  saatOnceligi:
    "Önce personelin kendi saati, yoksa şubenin gün bazlı saati, o da yoksa Genel Ayarlar'daki iş saatleri geçerlidir.",
  genelTip:
    "Her şubede hazır gelen tip. Hizmet seçmeden randevu açmak içindir; süresini Genel Ayarlar'dan alır.",
  iptalIade:
    "İptal satışı geri alır; stoklu üründe stok geri girer. Para iade etmez, ödenen kısım bakiyeye geçer. Nakit iade: Ödeme Al → Bakiye İade.",
  // BSL-STU §6
  dersTipiPaket:
    "Her ders tipi bir Studio paketi ürünüdür. Fiyat ve ders hakkı üründe durur; ürünü açınca tip de açılır.",
  paketSeans:
    "Pakette kaç ders hakkı olduğu. Yoklamada «Geldi» işaretlenen her ders bir hak düşürür.",
  // RH (BSL-URN/RDV) — satışa bağlı randevu hakkı
  hizmetHakki:
    "Randevu tipi bağlı hizmet ya da diyet paketi satılınca müşteriye o tipte seans hakkı açılır. Randevu formunda «Satın alınan hizmetler»den seçilir; «Geldi» işaretlenen randevu bir seans düşürür.",
  tumSubeler:
    "Açıksa üye paketi her şubenin dersinde kullanır; kapalıysa yalnız satıldığı şubede.",
  yoklama:
    "Geldi: paketten bir ders düşer. Gelmedi: dersin politikası «hak düşer» ise yine düşer, «düşmez» ise düşmez.",
  studioSaat:
    "Dersler bu gün ve saatlere göre denetlenir. Randevu modülü de varsa Randevu'daki iş saatleriyle aynı alandır.",
  // BSL-TKL §5
  onayEsigi:
    "İskonto, marj ya da tutar bu eşiği aşarsa teklif gönderilmeden önce onaycıya düşer. Boş bırakılan eşik kapalıdır. Kimse kendi teklifini onaylayamaz.",
  teklifDurumu:
    "Taslak: düzenlenebilir. Gönderildi: müşteride. Kazanıldı / Kaybedildi: müşterinin kararı. Gönderilen teklif değişmez; değişiklik «Revize Et» ile yeni sürümde yapılır.",
  maliyetAlti:
    "Birim fiyat ürünün güncel maliyetinin (son ürün girişi) altına inemez; satır «Maliyet altı fiyat» uyarısı verir ve teklif kaydedilmez.",
  gonderimMerkezi:
    "Gönderime hazır ve gönderilmiş teklifler burada: müşteri görüntüledi mi, kararı ne; buradan tekrar gönderebilirsiniz. Taslaklar görünmez; ilk gönderim Teklif Detayı'ndan yapılır.",
  // BSL-DST §6
  sorumluAtanan:
    "Sorumlu: kategoriye bağlı kişi, gelen çağrı ona düşer. Atanan: çağrının şu an üzerinde olan kişi. Açan: çağrıyı oluşturan.",
  oncelikSla:
    "Öncelik, çağrının ne kadar sürede yanıtlanıp çözüleceğini belirler. Süreler takvim dakikasıdır; mesai dışı da sayılır.",
  cozulduKapandi:
    "Çözüldü: çözüm yazıldı. Kapandı: Çözüldü'de birkaç gün kalan çağrı kendiliğinden kapanır; elle de kapatılabilir.",
  sirketimIcinde:
    "Şirketim İçinde: kendi ekibinize açılan çağrı. HepyApp Destek: HepyApp'e ilettiğiniz destek isteği.",
  // BSL-BLG §6
  koleksiyon:
    "Yazılarınızın sitede göründüğü sayfa. Yazı ancak yayındaysa ve aktif bir koleksiyondaysa dışarıdan görünür.",
  yayinDurumu:
    "Taslak: yalnız siz görürsünüz. Yayında: tarih gelince koleksiyonda görünür. Arşiv: yayından kalkar, silinmez.",
  kisaBaglanti:
    "Yazının adresindeki son parça. Değişirse eski bağlantı açılmaz; paylaşılmış yazıda değiştirmeyin.",
  // BSL-DYT §6
  danisan:
    "Diyet paketi satılmış müşteri. Danışanı eklediğinizde müşteri kaydı ve satış da açılır.",
  tekPlan:
    "Her danışanın bir planı olur. Süre paket süresinden gelir, en az 7 en fazla 70 gün. Yeni dönem için planı güncelleyin.",
  besinYemek:
    "Besin: katalogdaki tek gıda (örnek: yulaf). Yemek: sizin hazırladığınız, birden çok besinden oluşan tarif. İkisi de öğüne eklenir.",
  sablon:
    "Tekrar kullanmak için kaydettiğiniz plan. Şablondan başlayan plan şablonun kopyasıdır; şablon değişmez.",
};

export function kavram(anahtar) {
  return KAVRAMLAR[anahtar] || "";
}
